module.exports = __webpack_public_path__ + "static/media/meSwatch.83435a94.jpg";